import { render, staticRenderFns } from "./TypesOfWebsite.vue?vue&type=template&id=47310a5a&scoped=true"
import script from "./TypesOfWebsite.vue?vue&type=script&lang=js"
export * from "./TypesOfWebsite.vue?vue&type=script&lang=js"
import style0 from "./TypesOfWebsite.vue?vue&type=style&index=0&id=47310a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47310a5a",
  null
  
)

export default component.exports